import { createApi, fetchBaseQuery, retry } from "@reduxjs/toolkit/query/react";
import { RootState } from "../store";
import { selectAuthToken } from "@store/sessionReducer";
import { getEnvironment } from "@lib/getEnvironment";

export const getBaseUrl = () => {
  const environment = getEnvironment();
  if (environment === "development") {
    return window.location.origin;
  }

  if (environment === "staging") {
    return "//api.staging.visitwidget.com";
  }

  return "//api.visitwidget.com";
};

const baseQuery = fetchBaseQuery({
  baseUrl:
    // must include origin for `msw` to work, which is used for mocking api.
    getBaseUrl() + `/api/clients/${VisitWidget.settings.currentClientId}/`,
  prepareHeaders: (headers, { getState }) => {
    const token = selectAuthToken(getState() as RootState);

    if (token) {
      const authHeader = `Bearer ${token}`;
      headers.set("Authorization", authHeader);
    }

    return headers;
  },
});

const baseQueryWithRetry = retry(baseQuery, { maxRetries: 1 });

export const api = createApi({
  reducerPath: "api",
  baseQuery: baseQueryWithRetry,
  /**
   * This api has endpoints injected in adjacent files,
   * which is why no endpoints are shown below.
   */
  endpoints: () => ({}),
  tagTypes: [
    "Plan",
    "Place",
    "Icon",
    "MapMarker",
    "Tour",
    "Event",
    "Search",
    "Ad",
    "Goal",
    "FeedPost",
  ],
});
